import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { ConfigProvider, loadConfig } from "./config";
import "./styles.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element");
}
const root = createRoot(container);

loadConfig()
  .then((config) => {
    root.render(
      <StrictMode>
        <ConfigProvider config={config}>
          <App />
        </ConfigProvider>
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    console.error(error);
    root.render(
      <main className="boot-error">
        <h1>TryLook is temporarily unavailable</h1>
        <p>Please refresh the page in a moment.</p>
      </main>,
    );
  });
